import { createAppKit } from '@reown/appkit/react';
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi';
import { bsc as bscOriginal } from '@reown/appkit/networks';
import { injected } from 'wagmi/connectors';

export const projectId = 'eadb6d84806ee6c21e4dcdefd90db6ef'; // ID Reown Anda

// Mengatur Custom RPC Ankr untuk BSC
const bsc = {
  ...bscOriginal,
  rpcUrls: {
    default: { http: ['https://rpc.ankr.com/bsc/50e0aaab58b9711559929af784a0335fbe96741d743120c5dd906776fbbea412'] },
    public: { http: ['https://rpc.ankr.com/bsc/50e0aaab58b9711559929af784a0335fbe96741d743120c5dd906776fbbea412'] }
  }
};

export const networks = [bsc];

export const wagmiAdapter = new WagmiAdapter({
  ssr: false,
  networks,
  projectId,
  connectors: [injected()] 
});

const featuredWalletIds = [
  '4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0', // Trust Wallet
  '38f5d18bd8522c244bdd70cb4a68e0e718865155811c043f052fb9f1c51de662', // Bitget Wallet
  '', // OKX Wallet
  'c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96', // MetaMask
  '18388be9ac2d02726dbac9777c96efaac06d744b2f6d580fccdd4127a6d01fd1', // Rabby Wallet
  '8a0ee50d1f22f6651afcae7eb4253e52a3310b90af5daef78a8c4929a9bb99d4'  // Binance Web3 Wallet
];

createAppKit({
  adapters: [wagmiAdapter],
  networks,
  defaultNetwork: bsc, 
  projectId,
  featuredWalletIds,
  features: { email: false, socials: false, analytics: false },
  themeMode: 'dark', 
  themeVariables: {
    '--w3m-accent': '#00FF66', 
    '--w3m-color-fg-1': '#ffffff',
    '--w3m-color-fg-2': '#ffffff',
    '--w3m-color-fg-3': '#ffffff',
    '--w3m-color-bg-1': '#000000',
    '--w3m-color-bg-2': '#141414',
    '--w3m-color-bg-3': '#222222',
    '--w3m-color-mix': 'transparent',
    '--w3m-color-mix-strength': 0
  }
});